import { render, staticRenderFns } from "./Prunings.vue?vue&type=template&id=8e0538fc&scoped=true&lang=html&"
import script from "./Prunings.vue?vue&type=script&lang=js&"
export * from "./Prunings.vue?vue&type=script&lang=js&"
import style0 from "./Prunings.vue?vue&type=style&index=0&id=8e0538fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0538fc",
  null
  
)

export default component.exports